import { isEmpty } from "@utils/lodash";
import { useEffect } from "react";

export const useGetInitialSelectedVariant = ({
  variants,
  selectedVariantId,
  setSelectedVariant,
  defaultVariantIdSelection,
  preferDefaultVariantSelection = false,
  addonId,
  isCoverSelected,
  showModal
}: {
  variants: any[];
  selectedVariantId: string | null;
  setSelectedVariant: Function;
  defaultVariantIdSelection: string;
  preferDefaultVariantSelection?: boolean;
  addonId: string;
  isCoverSelected: boolean;
  showModal: boolean;
}) => {
  useEffect(() => {
    if (showModal && !isEmpty(variants)) {
      if (preferDefaultVariantSelection && defaultVariantIdSelection) {
        setSelectedVariant(
          variants?.find((v) => v?.variant_id === defaultVariantIdSelection)
        );
      } else if (isCoverSelected && selectedVariantId) {
        setSelectedVariant(
          variants?.find((v) => v?.variant_id === selectedVariantId)
        );
      } else {
        setSelectedVariant(
          variants?.find((v) => v?.variant_id === defaultVariantIdSelection)
        );
      }
    }
  }, [
    addonId,
    selectedVariantId,
    showModal,
    defaultVariantIdSelection,
    preferDefaultVariantSelection,
    isCoverSelected
  ]);
};
